import { makeStyles } from "@material-ui/core/styles";

const useStyles = makeStyles((theme) => ({
	darkHeader: {
		backgroundColor: "#261E1E",
		padding: "40px 20px 60px 20px",
		textAlign: "center",
		position: "relative",
		zIndex: 1,
	},
	successIconContainer: {
		width: 80,
		height: 80,
		borderRadius: "50%",
		backgroundColor: "#4CAF50",
		display: "flex",
		alignItems: "center",
		justifyContent: "center",
		margin: "0 auto 20px auto",
		border: "2px solid #4CAF50",
	},
	successIcon: {
		fontSize: 40,
		color: "white",
	},
	successTitle: {
		color: "white",
		fontSize: "24px",
		fontWeight: "bold",
		fontFamily: "CircularStd, sans-serif",
	},
	whiteCard: {
		backgroundColor: "#FDFBF8",
		margin: "-40px 20px 0 20px",
		borderRadius: "20px 20px 0 0",
		padding: "30px 20px",
		position: "relative",
		zIndex: 2,
		minHeight: "400px",
		display: "flex",
		flexDirection: "column",
		justifyContent: "space-between",
	},
	packageInfo: {
		marginBottom: "30px",
	},
	packageLabel: {
		fontSize: "16px",
		color: "#333",
		marginBottom: "8px",
		fontWeight: "500",
	},
	packageName: {
		fontSize: "18px",
		color: "#333",
		marginBottom: "8px",
		fontWeight: "bold",
	},
	serviceName: {
		fontSize: "16px",
		color: "#333",
		marginBottom: "8px",
		fontWeight: "500",
	},
	packageValue: {
		fontSize: "16px",
		color: "#333",
		marginBottom: "8px",
		fontWeight: "500",
	},
	businessName: {
		fontSize: "16px",
		color: "#333",
		fontWeight: "500",
	},
	infoText: {
		marginBottom: "30px",
	},
	infoLine: {
		fontSize: "14px",
		color: "#666",
		marginBottom: "8px",
		lineHeight: "1.4",
	},
	actionButton: {
		backgroundColor: "#7A2F3F",
		color: "white",
		padding: "12px 24px",
		borderRadius: "30px",
		fontSize: "16px",
		fontWeight: "bold",
		textTransform: "none",
		width: "100%",
		"&:hover": {
			backgroundColor: "#6A2636",
		},
	},
	paymentSummary: {
		margin: "20px",
		padding: "20px",
		backgroundColor: "white",
		borderRadius: "8px",
		boxShadow: "0 2px 8px rgba(0,0,0,0.1)",
	},

	successHeader: {
		paddingTop: "20px",
		textAlign: "center",
	},

	successIconContainer: {
		display: "flex",
		alignItems: "center",
		justifyContent: "center",
		width: "64px",
		height: "64px",
		backgroundColor: "#234038",
		borderRadius: "50%",
		marginBottom: "16px",
		margin: "0 auto 16px auto",
	},

	successIcon: {
		color: "#fff",
		fontSize: "45px",
	},

	successTitle: {
		fontSize: "clamp(28px, 1vw, 32px)",
		color: "#222",
		fontWeight: "bold",
		textAlign: "center",
	},

	headerBusinessBar: {
		display: "flex",
		alignItems: "center",
		justifyContent: "flex-start",
		margin: "20px 20px",
	},

	headerAvatar: {
		width: 56,
		height: 56,
		backgroundColor: "#8C1837",
	},

	headerTexts: {
		display: "flex",
		flexDirection: "column",
		marginLeft: 16,
		minHeight: 100,
	},

	headerName: {
		fontSize: "clamp(24px, 2vw, 26px)",
		fontWeight: 600,
		color: "#222",
		lineHeight: 1.2,
		marginTop: 4,
	},

	headerInfoUnderlined: {
		fontSize: "12px",
		color: "#222",
		lineHeight: 1.3,
		marginTop: 2,
		textDecoration: "underline",
		cursor: "pointer",
		marginTop: 10,
		marginBottom: 10,
	},

	headerInfo: {
		fontSize: "14px",
		color: "#222",
		lineHeight: 1.2,
		marginTop: 2,
	},
}));

export default useStyles;